import { BaseResponse, RequestConfig } from 'common/types/api'
import axios from 'core/api'
import { GeneralType } from 'modules/pond/api/types'

import { buildUrlWithParams } from 'utils/url'

import { FoodBrand, FoodSize, FoodToday, GetFoodSizeParams, ProductByFood, Protein } from './types'

export const FOOD_REQUEST_CONFIG: RequestConfig = {
  getMeals: { method: 'GET', url: '/meals' },
  getMealsByProduct: { method: 'GET', url: '/meals/product' },
  getFoods: { method: 'GET', url: '/foods' },
  getFoodLineChart: { method: 'GET', url: '/foods/line-chart' },
  getRecentFood: { method: 'GET', url: '/foods/recent' },
  getRecentFoodByProduct: { method: 'GET', url: '/foods/recent/product' },
  createMeal: { method: 'POST', url: '/foods' },
  editMeal: { method: 'PATCH', url: '/meals' },
  deleteFood: { method: 'DELETE', url: '/foods' },
  partials: { method: 'GET', url: '/partials' },
  createProduct: { method: 'POST', url: '/product/food' },
  createNaturalProduct: { method: 'POST', url: '/product/natural-food' },
  createMealByProduct: { method: 'POST', url: '/foods/product' },
}

export const getFoodSizes = (params: GetFoodSizeParams) =>
  axios.get<BaseResponse<FoodSize[]>>(
    buildUrlWithParams('/food-sizes', {
      ...params,
    })
  )

export const getFeedingTypes = () => axios.get<BaseResponse<GeneralType[]>>('/feeding-types')

export const getFoodBrands = (speciesId: number) =>
  axios.get<BaseResponse<FoodBrand[]>>(`/${speciesId}/food-brands`)

export const getProteins = (foodbrandId: number, speciesId: number) =>
  axios.get<BaseResponse<Protein[]>>(
    buildUrlWithParams(`/food-brands/${foodbrandId}/proteins`, { speciesId })
  )

export const getFoodToday = (farmId: string, pondId: string, cycleId: string) =>
  axios.get<BaseResponse<FoodToday>>(`/farms/${farmId}/ponds/${pondId}/cycles/${cycleId}/foods/today`)

export const getListProductByFood = (farmId: string, pondId: string, cycleId: string) =>
  axios.get<BaseResponse<ProductByFood[]>>(`/farms/${farmId}/ponds/${pondId}/cycles/${cycleId}/foods/product/list`)

export const getListNaturalProductByFood = (farmId: string, pondId: string, cycleId: string) =>
  axios.get<BaseResponse<ProductByFood[]>>(`/farms/${farmId}/ponds/${pondId}/cycles/${cycleId}/foods/product/natural-food/list`)
